// src/lib/hooks/admin/useUsageOverview.ts
import { useQuery } from '@tanstack/react-query';
import { fetchUsageOverview } from '@/lib/api/admin';
import type { UsageFilters, OverviewData, UsersFilters } from '@/types/admin';

export const usageKeys = {
  all: ['admin', 'usage'] as const,
  overview: (f: UsageFilters) => [...usageKeys.all, 'overview', f] as const,
  users: (f: UsersFilters) => [...usageKeys.all, 'users', f] as const,
  tenants: (f: { from: string; to: string }) => [...usageKeys.all, 'tenants', f] as const,
  timeseries: (f: UsageFilters) => [...usageKeys.all, 'timeseries', f] as const,
};

export const useUsageOverview = (filters: UsageFilters, enabled = true) => {
  return useQuery<OverviewData>({
    queryKey: usageKeys.overview(filters),
    queryFn: () => fetchUsageOverview(filters),
    enabled,
    staleTime: 60 * 1000,
  });
};
